
export default async function ForgotPasswordActionHandler(json) {
    if(/^\/account\/login\/forgotpassword/i.test(window.location.pathname)) {
        try {
            document.getElementById("Email").value = json.email;
            setTimeout(() => {
                document.getElementById("submit-forgot-password").click()
            }, 10);
            return {success: true};
        } catch (error) {
            return {success: false, error};
        }
    } else {
        return {success: false, error: new Error("Not on forgot password page.")};
    }
}

